// @vue-js-cron/light choisit toujours la DERNIÈRE période de la liste
// ("année") comme période par défaut à l'ouverture du générateur, quel
// que soit le contenu de l'expression cron déjà présente (voir data()
// dans @vue-js-cron/core: selectedPeriod: this.periods[this.periods.length-1]).
// Résultat : ouvrir un cron existant simple (ex: "0 0 * * MON") affiche
// une phrase complète "Chaque année en chaque mois..." au lieu de la
// période la plus courte qui correspond réellement ("Chaque semaine").
//
// Cette fonction réordonne la liste des périodes pour placer en dernière
// position celle qui correspond le mieux à l'expression cron fournie
// (la plus petite période dont les champs couvrent tous les champs
// non wildcard de l'expression), afin que le générateur s'ouvre sur la
// description la plus courte possible.

const FIELD_ORDER = ["minute", "hour", "day", "month", "dayOfWeek"];

export function order_periods_for_value(periods, value) {
	if (!value) return periods;

	const fields = value.trim().split(/\s+/);
	if (fields.length !== FIELD_ORDER.length) return periods;

	const active_fields = FIELD_ORDER.filter((id, idx) => fields[idx] !== "*");

	const best = periods.find((period) =>
		active_fields.every((id) => period.value.includes(id))
	);
	if (!best) return periods;

	return [...periods.filter((period) => period !== best), best];
}
